import React, {useEffect} from "react";
import fetcher from 'lib/utils/fetcher'
import SeoData from '@/components/core/SeoData'
import contentStyles from "@/public/styles/pages/blog/post/content.module.scss";
import Image from 'next/image';
import Breadcrumbs from "@/components/common/Breadcrumbs";
import cx from 'classnames';
import {serialize} from "next-mdx-remote/serialize";
import {MDXRemote} from "next-mdx-remote";
import {wrapper} from "@/store/store";
import {connect} from "react-redux";
import AppDefaultBanner from "@/components/common/AppDefaultBanner";

const API_HOST = process.env.NEXT_PUBLIC_API_URL
const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN
const IMAGE_HOST = process.env.NEXT_PUBLIC_API_IMAGE_URL

const components = {
    Image
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    ctx.res.setHeader(
        "Cache-Control",
        "max-age=300, stale-while-revalidate=60, stale-if-error=86400"
    );

    if (!ctx.params) {
        return {
            notFound: true,
        }
    }
    const {urlKey} = ctx.params;
    let exercise: any = false;

    try {
        let fetchUrl = `${API_HOST}/api/training/exercise/${urlKey}`
        exercise = await fetcher(fetchUrl);
    } catch (e) {
        console.log(e.message)
    }

    if (!exercise) {
        return {
            notFound: true,
        }
    }

    let preparedContent = await serialize(prepareData(exercise.description));

    return {
        props: {
            exercise: exercise,
            preparedContent: preparedContent
        }
    };
})

function Post(props) {
    const {exercise, preparedContent, isMobile} = props
    let postCategory = exercise.category

    const postUrl = `${DOMAIN}/exercise/${exercise.urlKey}`

    let breadcrumbs = [];

    breadcrumbs.push({
        path: `${DOMAIN}/exercises`,
        title: 'Упражнения'
    })

    breadcrumbs.push({
        path: `${DOMAIN}/exercises/` + postCategory.urlKey,
        title: postCategory.name
    })

    breadcrumbs.push({
        path: '',
        title: exercise.name,
        disabled: true
    })

    console.log(exercise.bigImage?.fileUrl)

    // @ts-ignore
    return (
        <>
            <SeoData title={exercise.metaTitle}
                     description={exercise.metaDescription}
                     keywords={exercise.metaKeyword}
                     article={
                         {
                             category: "Упражнения",
                             tags: [],
                             created_at: exercise.createdAt,
                             updated_at: exercise.updatedAt
                         }
                     }
                     image={`${IMAGE_HOST}${exercise.bigImage?.fileUrl}`}
                     ogType={'article'}
                     hideFromRobots={false}/>

            {
                !isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }

            <div className={cx(contentStyles.contentContainer, {[contentStyles.noCrumbs]: isMobile})}>
                <h1 className={contentStyles.postTitle}>{exercise.name}</h1>
                <div className={contentStyles.postDescription} dangerouslySetInnerHTML={{__html: exercise?.descriptionShort}}/>
                <div className={contentStyles.additionalData}>
                    <div className={contentStyles.author}>
                        <Image src='/images-local/author.png' width={48} height={48}/>
                        <span>Редакция Wayout</span>
                    </div>
                </div>
                {
                    isMobile &&
                    <AppDefaultBanner />
                }
                <div className={contentStyles.postImage}>
                    {exercise.bigImage?.fileUrl &&
                        <div className={contentStyles.postImage}>
                            <Image alt={`${exercise.name}`} src={`${IMAGE_HOST}${exercise.bigImage?.fileUrl}`}
                                   width={792} height={365} quality={100} priority/>
                        </div>
                    }
                </div>

                <div className={contentStyles.postContent}>
                    <MDXRemote {...preparedContent} components={components} />
                 </div>

                {
                    isMobile &&
                    <div className={contentStyles.appBanner}><AppDefaultBanner /></div>
                }
                <div className={cx('video-container')}><iframe className={cx('ql-video', 'ql-align-justify')} src={exercise.videoLink} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  frameBorder="0" allowFullScreen></iframe></div>

            </div>
            {
                isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }
        </>

    )
}

function prepareData(content) {
    content = content.replaceAll('<iframe', '<div class="video-container"><iframe');
    content = content.replaceAll('\/iframe>', '/iframe></div>')

    content = content.replaceAll('<br>', '<br />')

    content = content.replaceAll('<img', '<div class="image-container"><Image className="image" layout="fill"')
    content = content.replaceAll(/(<Image("[^"]*"|[^\/">])*)>/gi, "$1/></div>");

    content = content.replaceAll(/(style="(.*?)")/gi, "");

    return content
}

function mapStateToProps(state) {
    return {
        isMobile: state.core.is_mobile
    }
}

export default connect(mapStateToProps)(Post)
